
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
    components: {  }
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.MerchantClientServiceProxy();
    }
    sub_id = 0;
    createOrEditShow = false;
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '名称',
            key: 'channelTypeName'
        },
        {
            title: '编号',
            key: 'code'
        },
        {
            title: '费率(%)',
            key: 'rate'
        },
        
    ];
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
     
        this.prox.queryChannelTypes().then(x => {
            this.dataList = x;
            //this.showPaging(x);
        });
    }

    getpage() {
        this.OnInit();
    }
    async created() {
        this.getpage();
    }
    create() {
        this.createOrEditShow = true;
        this.sub_id = undefined;
    }
    edit(row) {
        if (!row) {
            if (this.selectedDataItems.length == 0) {
                this.$Notice.error({ title: '请选中一条数据' });
                return;
            }
            row = this.selectedDataItems[0];
        }
        this.sub_id = row.id;
        this.createOrEditShow = true;
    }
 
}
